module.exports = __webpack_public_path__ + "static/media/humza icons-02.3d1f0174.svg";